import { observable, configure, action, computed } from 'mobx';
import StoreModel from './storeModel';

configure({ enforceActions: 'always' });

class MaillogStore extends StoreModel {
    constructor() {
        super('maillog', {
            namePlural: 'maillogs',
            sort: '-createdDate',
            api: {
                search: {
                    url: '/api/maillog/',
                    params: {},
                },
                load: {
                    url: '/api/maillog/',
                    params: {},
                },
                save: {
                    url: '/api/maillog/',
                    params: {},
                },
            },
            queryFilter: {},
        });
    }

    @observable maillog = {};

    @observable maillogs = [];
}

const store = new MaillogStore();
export default store;



// WEBPACK FOOTER //
// ./stores/maillog.js